export default __webpack_public_path__ + "static/worker-0d5a772cc351f0fac63d078b262797d9.jpeg";